module.exports = __webpack_public_path__ + "media/application/images/ui/logo-f08d14f82f93e6ef521b5fc58c6a6033.png";